import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {  putAPI } from "../service/http-service";
import { AuthApi } from "../auth/authEndpointConfig/AuthEndpointConfig";

export interface verifyOTP {
  email: string;
  mobileNo: any;
  otp: number;
}

let initialState: any = {
  loading: false,
  entity: {
    resetPassResponse: "",
  },
};

//Verify OTP API call
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (requestParam: verifyOTP) => {
    try {
      const response = await putAPI(AuthApi.resetPassword, requestParam);
      return response;
    } catch (err) {
      return err;
    }
  }
);
const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.entity.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPassword.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.entity.resetPassResponse = action.payload;
      state.loading = false;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const resetPasswordReducer = resetPasswordSlice.reducer;
export default resetPasswordReducer;
